import React from 'react';

import InfoColumn, { InfoColumnProps } from './columns/InfoColumn';
import ListColumn, { ListColumnProps } from './columns/ListColumn';

import './GreenBoxWithList.scss';

interface GreenBoxWithListProps extends React.HTMLAttributes<HTMLDivElement> {
    /** Optional additional class names */
    className?: string;
    /** Pass \<GreenBoxWithList.Item /> as children. */
    children?: React.ReactNode;
}

interface GreenBoxWithListComponent {
    /** InfoColumn */
    InfoColumn: React.FC<InfoColumnProps>;
    /** ListColumn */
    ListColumn: React.FC<ListColumnProps>;
}

const GreenBoxWithList: React.FC<GreenBoxWithListProps> & GreenBoxWithListComponent = ({
    className,
    children,
    ...rest
}: GreenBoxWithListProps) => (
    <div {...rest} className={`kortbetjening-green-box-with-list-wrapper ${className ?? ''}`}>
        {children}
    </div>
);

GreenBoxWithList.InfoColumn = InfoColumn;
GreenBoxWithList.ListColumn = ListColumn;

export default GreenBoxWithList;
